export function DepartmentIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M21 17.967V10.15c0-1.21-.54-2.357-1.47-3.123l-5-4.118a3.975 3.975 0 00-5.06 0l-5 4.118A4.046 4.046 0 003 10.15v7.817C3 20.194 4.79 22 7 22h10c2.21 0 4-1.806 4-4.033z"
        opacity="0.4"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M8 10.25a.75.75 0 01.75.75v4a.75.75 0 01-1.5 0v-4a.75.75 0 01.75-.75zM16 10.25a.75.75 0 01.75.75v4a.75.75 0 01-1.5 0v-4a.75.75 0 01.75-.75zM12 8.25a.75.75 0 01.75.75v8a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75z"
        clipRule="evenodd"
      />
    </svg>
  );
}
